import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import {useTranslation} from '@/translations/i18n.tsx'
import {ChatMessage} from '@features/ai-chatbot/types.ts'
import {cn} from '@utilities/helpers'

export const MessageBubble = ({message}: {message: ChatMessage}) => {
    const {t} = useTranslation()
    const isUser = message.role === 'user'
    const content = message.isError ? t('errors:default') : message.content

    return (
        <div className={cn('mb-3 flex', isUser ? 'justify-end' : 'justify-start')}>
            <div
                className={cn(
                    // Elevate rebuilds the radius scale (its `3xl` is 16px, `sm` 2px); these
                    // are the same pixel values in this theme's default scale.
                    'max-w-[85%] rounded-2xl px-3 py-2 text-sm wrap-break-word',
                    '[&_p]:wrap-break-word [&_p]:whitespace-pre-wrap',
                    '[&_a]:break-all [&_a]:underline [&_a]:underline-offset-2',
                    '[&_strong]:font-semibold',
                    '[&_ol]:ml-4 [&_ul]:ml-4 [&_ul]:list-disc [&_ol]:list-decimal',
                    '[&_code]:rounded-sm [&_code]:bg-grey-300 [&_code]:px-1 [&_code]:py-0.5 [&_code]:text-xs',
                    isUser ? 'rounded-br-xs bg-grey-1000 text-white' : 'rounded-bl-xs bg-grey-200 text-grey-1000'
                )}
            >
                {isUser || message.isError ? (
                    <p>{content}</p>
                ) : (
                    <ReactMarkdown
                        remarkPlugins={[remarkGfm]}
                        components={{
                            a: ({href, children}) => (
                                <a href={href} rel="noopener noreferrer" target="_blank">
                                    {children}
                                </a>
                            )
                        }}
                    >
                        {content}
                    </ReactMarkdown>
                )}
            </div>
        </div>
    )
}

MessageBubble.displayName = 'MessageBubble'
